import { Outlet } from 'react-router-dom';

// project imports
import Customization from '../Customization';
import MerchantRouteWatcher from 'layout/MerchantRouteWatcher';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
  <>
    <MerchantRouteWatcher />
    <Outlet />
    {/* <Customization /> */}
  </>
);

export default MinimalLayout;
